import React, { useEffect } from 'react';
import { NavObjectType, lddGlobalSessionInfo } from '../Components/navigationTypes';
import Loading from '../Components/Loading';
import { Badge, Col, Row } from 'react-bootstrap';
import { DRDataReader, getDRDataReader } from '../livedataFuncs';
import DRListContainer from './Components/DRListContainer';
import { useAppSelector } from '../redux/hooks';
import { useDispatch } from 'react-redux';
import { setRoot, setRootUndef } from '../redux/reducer';
import { isPageInDrFile, isPageInDrPasscodeFile } from './Components/drFuncs';
import styles from "./../Components/Home/MainPage.module.scss";

const MainPage = (props: {
    info: lddGlobalSessionInfo,
    page: NavObjectType,
    dataroot: any,
    iframeProp: React.JSX.Element,
    reactFileComponent: React.JSX.Element
}) => {
    const sessionInfo: lddGlobalSessionInfo = useAppSelector((state) => state.SessionInfo);
    const dispatch = useDispatch();
    useEffect(() => {
        if (!props.page?.params?.id) {
            return;
        }

        let url;
        if (isPageInDrFile(props.page)) {
            // in dr file, set dataroot
            if (isPageInDrPasscodeFile(props.page)) {
                url = `${process.env.REACT_APP_DSAPI_ENDPOINT}/dr/passcode/msgxml?MsgID=${props.page.params.id}&PassCode=${props.page.params.PassCode}`;
            } else {
                url = `${process.env.REACT_APP_DSAPI_ENDPOINT}/dr/${sessionInfo.firm.id}/${sessionInfo.user.account}/msgxml?MsgID=${props.page.params.id}&SessionID=${sessionInfo.sid}`;
            }
            fetch(url)
                .then((response) => {
                    if (response.ok) {
                        response.text().then((textData) => {
                            let xmlDom = new ajaxslt.XDocument();
                            xmlDom.loadXML(textData);
                            let doc = xmlDom.documentElement;
                            if (doc.nodeName === 'Root' && doc.firstChild.nodeName === 'TPAppXML') {
                                // append VIPInfo to TPAppXML
                                doc.firstChild.appendChild(doc.selectSingleNode("VIPInfo"));
                                doc = doc.firstChild;
                            }
                            if (doc.nodeName === 'TPAppXML') {
                                dispatch(setRoot(doc as any));
                            }
                        })
                    } else {
                        // nav to login page
                        window.location.href = `/${process.env.REACT_APP_DR_ENDPOINT}/loginldd.html`
                    }
                })
        } else {
            dispatch(setRootUndef());
        }
    }, [props.page?.params?.id])
    
    let openDrawer = 'regular-frame';
    if (props.page.component === 'main' && props.dataroot) {
        openDrawer = 'dr-frame'
    }
    let DataReaderObj: DRDataReader;
    if (props.dataroot) {
        DataReaderObj = getDRDataReader(props.dataroot);
    }
    function GetMainComponent(): React.ReactElement {
        if (props.info) {
            let component;
            switch (props.page.component) {
                case 'main':
                    return <></>;
                case 'dr':
                    component = <DRListContainer />;
                    break;
                default:
                    break;
            }
            return component;
        } else {
            return <Loading />;
        }
    }

    return (
        <div className={"internal-component " + openDrawer} >
            <div className="file-container" style={{
                display: props.page.component === "dr" ? 'none' : ''
            }}>
                {isPageInDrFile(props.page) && (props.dataroot ?
                    <div className={"reline " + styles.reline}>
                        <Row className="mb-2">
                            <Col>
                                <span className={styles.label}>
                                    <i className="fa-solid fa-folder"></i>
                                    New Home
                                </span>
                                <b className={styles.fileName}>{DataReaderObj.getFileNumber()}</b>
                            </Col>

                            <Col style={{ display: 'flex', justifyContent: 'end', marginTop: '10px'}}>
                                {DataReaderObj.getBuyerLawyerName() &&
                                    <Badge bg="info" pill>
                                        <i className="fa-duotone fa-scale-balanced"></i>
                                        {DataReaderObj.getBuyerLawyerName()}
                                    </Badge>
                                }

                                {DataReaderObj.getBuyerMainContactName() &&
                                    <Badge bg="info" pill>
                                        <i className="fa-duotone fa-user"></i>
                                        {DataReaderObj.getBuyerMainContactName()}
                                    </Badge>
                                }
                            </Col>
                        </Row>

                        <Row>
                            <Col style={{ display: 'flex', alignItems: 'center'}}>
                                <i className="fa-duotone fa-house" style={{ marginRight: '5px', cursor: 'auto' }}></i>
                                {DataReaderObj.getPropertyAddress()}
                            </Col>
                        </Row>
                    </div>
                 : <Loading />)}
                
                {/* Legacy Frame */}
                <div style={{ display: (props.page.reactFrame !== undefined && props.page.reactFrame !== '') ? 'none' : '' }}>
                    {props.iframeProp}
                </div>

                {/* React Frame */}
                {(props.page.reactFrame !== undefined && props.page.reactFrame !== '' && props.dataroot) &&
                    <div className="react-frame">
                        {props.reactFileComponent}
                    </div>
                }
                
            </div>
            
            {!props.page.reactFrame && GetMainComponent()}
        </div>
    )
}

export default MainPage;